class GridViewToggle {
  constructor(el) {
    this.el = el;
    this.buttons = el.querySelectorAll('[data-grid-cols]');
    this.buttons.forEach((btn) => {
      btn.addEventListener('click', () => this.setColumns(btn));
    });
  }

  setColumns(activeBtn) {
    const cols = activeBtn.dataset.gridCols;
    this.buttons.forEach((btn) => btn.classList.toggle('is-active', btn === activeBtn));

    const grid = document.getElementById('product-grid');
    if (!grid) return;
    grid.className = grid.className.replace(/grid--\d+-col-desktop/g, '').trim();
    grid.classList.add(`grid--${cols}-col-desktop`);
  }
}

function initGridToggle() {
  document.querySelectorAll('[data-grid-toggle]').forEach((el) => {
    if (!el.dataset.gridToggleInit) {
      el.dataset.gridToggleInit = 'true';
      new GridViewToggle(el);
    }
  });
}

document.addEventListener('DOMContentLoaded', initGridToggle);

// Keep the chosen column count applied even after AJAX re-renders the grid
document.addEventListener('DOMContentLoaded', () => {
  const container = document.getElementById('ProductGridContainer');
  if (!container) return;
  new MutationObserver(() => {
    const activeBtn = document.querySelector('[data-grid-toggle] [data-grid-cols].is-active');
    const grid = document.getElementById('product-grid');
    if (activeBtn && grid) {
      grid.className = grid.className.replace(/grid--\d+-col-desktop/g, '').trim();
      grid.classList.add(`grid--${activeBtn.dataset.gridCols}-col-desktop`);
    }
  }).observe(container, { childList: true, subtree: false });
});